<!--
 * @Description: 金融机构列表
 * @Author: yangsibo
 * @Date: 2022-11-09 14:45:04
 * @LastEditors: juanjuanhui
 * @LastEditTime: 2024-01-09 17:11:52
 * @FilePath: /adm.xiangli360.com/src/views/Bank/BankManage/List.vue
-->
<template>
    <el-main>
        <div class="top-wrap">
            <Bread></Bread>
            <div>
                <el-form ref="filterForm" :inline="true" :model="filterForm" class="filter-form">
                    <el-form-item prop="bankName">
                        <!-- <el-input class="city-select" v-model="filterForm.bankName" placeholder="金融机构名称"></el-input> -->
                        <el-autocomplete v-model="filterForm.bankName" :fetch-suggestions="bankAssociate" placeholder="金融机构名称" 
                            label="name" value="value" value-key="name" :trigger-on-focus="false"></el-autocomplete>
                    </el-form-item>
                    <el-form-item prop="loginName">
                        <el-input class="city-select" v-model="filterForm.loginName" placeholder="账号"></el-input>
                    </el-form-item>
                    <el-form-item prop="fullName">
                        <el-input class="city-select" v-model="filterForm.fullName" placeholder="联系人"></el-input>
                    </el-form-item>
                    <el-form-item prop="businessZoneId">
                        <el-cascader ref="regionCascader" :options="businessZoneList" :props="zoneProps"
                            v-model="checkedZone" placeholder="业务区域"></el-cascader>
                    </el-form-item>
                    <el-form-item prop="businessPersonId">
                        <el-select class="city-select" :disabled="checkedZone.length == 0"
                            v-model="filterForm.businessPersonId" placeholder="业务负责人">
                            <!-- <el-option label="全部" :value="null"></el-option> -->
                            <el-option v-for="(item, index) in dutyPersonList" :key="index" :label="item.personName"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="handleFilter()">查询</el-button>
                        <el-button type="primary" plain icon="el-icon-refresh-right" @click="handleReset('filterForm')">
                            清空
                        </el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="main">
            <!--  -->
            <el-table :data="tableData" style="width: 100%; margin-top: 10px">
                <el-table-column label="序号" width="80" align="center">
                    <template slot-scope="scope">
                        {{
                                (pagination.currentPage - 1) * pagination.pageSize +
                                (scope.$index + 1)
                        }}
                    </template>
                </el-table-column>
                <el-table-column prop="bankName" label="金融机构名称" min-width="10%" align="center">
                </el-table-column>
                <el-table-column prop="businessOutlets" label="业务网点" min-width="10%" align="center">
                </el-table-column>
                <el-table-column prop="commandArea" label="管辖地区" min-width="10%" align="center">
                </el-table-column>
                <el-table-column prop="loginName" label="登录账号" min-width="10%" align="center"></el-table-column>
                <el-table-column prop="fullName" label="联系人" min-width="7%" align="center"></el-table-column>˝
                <el-table-column prop="mobile" label="登陆手机号" min-width="10%" align="center"></el-table-column>
                <el-table-column prop="subDomain" label="登录地址" min-width="15%" align="center"></el-table-column>
                <el-table-column prop="statusFlagName" label="状态" min-width="5%" align="center"></el-table-column>
                <el-table-column prop="businessZoneName" label="业务区域" min-width="10%" align="center"></el-table-column>
                <el-table-column prop="businessPersonName" label="业务员" min-width="7%" align="center"></el-table-column>
                <!-- <el-table-column prop="createTime" label="创建时间" min-width="10%" align="center"></el-table-column> -->
                <el-table-column label="操作" min-width="15%" align="center">
                    <template slot-scope="{ row }">
                        <el-button type="primary" plain round size="small" @click="handleInfo(row, 'reset')">重置
                        </el-button>
                        <el-button type="primary" plain round size="small" @click="handleInfo(row, 'update')">修改
                        </el-button>
                        <el-button type="primary" @click="handleStatus(row, $event)" plain round size="small">
                            {{ `${row.statusFlag == 20 ? "启用" : "停用"}` }}
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination background layout="total,prev, pager, next,jumper" :page-size="pagination.pageSize"
                :total="pagination.total" :hide-on-single-page="true" @current-change="handleCurrentChange">
            </el-pagination>
        </div>
        <!-- 重置账号弹窗 -->
        <el-dialog class="dialog-bg" title="重置密码" :visible.sync="dialogResetVisible" width="550px">
            <el-form :model="currentData" :rules="resetRules" ref="resetForm" label-width="100px">
                <el-form-item label="金融机构名称">
                    <el-autocomplete disabled v-model="currentData.bankName" :fetch-suggestions="bankAssociate" placeholder="金融机构名称" 
                        label="name" value="value" value-key="name" :trigger-on-focus="false"></el-autocomplete>
                </el-form-item>
                <el-form-item label="业务网点" prop="businessOutlets">
                    <el-input disabled v-model="currentData.businessOutlets" placeholder="请填写业务网点"></el-input>
                </el-form-item>
                <el-form-item label="登录账号">
                    <el-input disabled v-model="currentData.loginName"></el-input>
                </el-form-item>
                <el-form-item label="新密码" prop="userPassword">
                    <el-input type="userPassword" ref="userPassword" auto-complete="new-password" autocomplete="off"
                        v-model="currentData.userPassword" placeholder="请填写新的登录密码"></el-input>
                </el-form-item>

            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogResetVisible = false">取消</el-button>
                <el-button type="primary" @click="handleResetInfo('resetForm')">提交</el-button>
            </span>
        </el-dialog>
        <!-- 修改账号弹窗 -->
        <el-dialog class="dialog-bg dialog-add" title="修改账号" :visible.sync="dialogUpdateVisible" width="750px">
            <el-form :model="currentData" :rules="updateRules" ref="updateForm" label-width="120px">
                <el-form-item label="登录账号">
                    <el-input disabled v-model="currentData.loginName"></el-input>
                </el-form-item>
                <el-form-item label="金融机构名称" prop="bankName">
                    <el-autocomplete v-model="currentData.bankName" :fetch-suggestions="bankAssociate" placeholder="金融机构名称" 
                        label="name" value="value" value-key="name" :trigger-on-focus="false"></el-autocomplete>
                </el-form-item>
                <el-form-item label="业务网点" prop="businessOutlets">
                    <el-input v-model="currentData.businessOutlets" placeholder="请填写业务网点"></el-input>
                </el-form-item>
                <el-form-item label="姓名" prop="fullName">
                    <el-input v-model="currentData.fullName" placeholder="请填写姓名"></el-input>
                </el-form-item>
                <el-form-item label="手机号码" class="mobile-form-item" prop="mobile">
                    <el-input maxlength="11" v-model="currentData.mobile" placeholder="请填写手机号码"></el-input>
                </el-form-item>
                <el-form-item label="登录地址" prop="subDomain" class="sub-domain-item">
                    <div class="login-tip">登录地址2~20位，支持数字和小写字母。</div>
                    <el-input v-model="currentData.subDomain" placeholder="请填写登录地址">
                        <i slot="suffix">
                            -bank
                        </i>
                        <template slot="prepend">http://</template>
                        <template slot="append">.xiangli360.com</template>
                    </el-input>
                </el-form-item>
                <el-form-item label="业务区域" prop="businessZoneId">
                    <el-cascader ref="regionCascader" :options="businessZoneList" :props="zoneProps"
                        v-model="currentData.businessZoneId" placeholder="业务区域"></el-cascader>
                </el-form-item>
                <el-form-item label="业务负责人" prop="businessPersonId">
                    <el-select class="city-select" v-model="currentData.businessPersonId" placeholder="业务负责人">
                        <!-- <el-option label="全部" :value="null"></el-option> -->
                        <el-option v-for="(item, index) in currentDutyPersonList" :key="index" :label="item.personName"
                            :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogUpdateVisible = false">取消</el-button>
                <el-button type="primary" @click="handleSaveInfo('updateForm')">提交</el-button>
            </span>
        </el-dialog>
    </el-main>
</template>

<script>
import common from '@/utils/common.js';
export default {
    name: 'BankManageList',
    data() {
        return {
            filterForm: {
                bankName: '',
                fullName: '',
                businessZoneId: '', //业务区域id
                businessPersonId: '', //业务负责人id
                loginName: '',
                // pageType: 5,
            },
            pagination: {
                currentPage: 1,
                pageSize: 10,
                total: 0,
            },
            tableData: [],
            businessZoneList: [], //业务区域数据
            zoneProps: {
                value: 'id',
                label: 'zoneName',
                children: 'children',
            },
            checkedZone: [], //选中的业务区域
            dutyPersonList: [],
            dialogResetVisible: false,
            currentData: {},
            resetRules: {
                userPassword: [
                    { required: true, message: '请填写6-20位账号密码', trigger: 'blur' },
                    {
                        min: 6,
                        max: 20,
                        message: '请输入6-20位账号密码',
                        trigger: 'blur',
                    },
                ],
            },
            dialogUpdateVisible: false,
            currentCheckedZone: [],
            currentDutyPersonList: [],
            updateRules: {
                fullName: [
                    { required: true, message: '请填写联系人名称', trigger: 'blur' },
                ],
                mobile: [
                    { required: true, message: '请填写手机号码', trigger: 'blur' },
                    { validator: common.checkMobile, required: true, trigger: 'blur' },
                ],
                subDomain: [
                    { required: true, message: '请填写登录地址', trigger: 'blur' },
                    { trigger: 'blur', validator: common.checkSubDomain },
                    { min: 2, max: 20, message: '长度在4到20位', trigger: 'blur' },
                ],
                businessZoneId: [
                    { required: true, message: '请选择业务区域', trigger: 'blur' },
                ],
                businessPersonId: [
                    { required: true, message: '请选择业务员', trigger: 'blur' },
                ],
            },
            oldRowData: {},
        };
    },
    components: {},
    watch: {
        checkedZone(newVal) {
            this.filterForm.businessPersonId = '';
            this.dutyPersonList = [];
            this.filterForm.businessZoneId =
                newVal.length > 0 ? newVal[newVal.length - 1] : '';
            newVal.length > 0 && this.getDutyPerson();
        },
        currentCheckedZone(newVal) {
            this.currentData.businessPersonId = '';
            this.dutyPersonList = [];
            this.currentData.businessZoneId =
                newVal.length > 0 ? newVal[newVal.length - 1] : '';
            newVal.length > 0 && this.getCurrentDutyPerson();
        },
    },
    created() {
        this.getBusinessZoneData();
        this.getCtCountyAccountPage();
    },
    mounted() { },
    methods: {
        //页码切换
        handleCurrentChange(val) {
            this.pagination.currentPage = val;
            this.getCtCountyAccountPage();
        },
        /**
         * @Description: 获取县系统列表
         * @Author: yangsibo
         * @Date: 2022-09-28 19:49:10
         * @return {*}
         */
        async getCtCountyAccountPage() {
            try {
                let { data } = await this.$http.bank.getFinanceAccounListPage({
                    ...this.pagination,
                    ...this.filterForm,
                });
                this.tableData = data.content;
                this.pagination.total = data.recordTotal;
            } catch (error) {
                console.log(error);
            }
        },
        // 获取业务区域数据
        getBusinessZoneData() {
            this.$http.common.getBusinessZoneList({}).then((res) => {
                this.businessZoneList = res.data;
            });
        },
        // 获取业务负责人
        getDutyPerson() {
            this.$http.common
                .getDutyPerson({ businessZoneId: this.filterForm.businessZoneId })
                .then((res) => {
                    this.dutyPersonList = res.data;
                });
        },
        // 账号更新业务员
        getCurrentDutyPerson() {
            this.$http.common
                .getDutyPerson({ businessZoneId: this.currentData.businessZoneId })
                .then((res) => {
                    this.currentDutyPersonList = res.data;
                });
        },
        // 查询
        handleFilter() {
            this.pagination.currentPage = 1;
            this.getCtCountyAccountPage();
        },
        //重置
        handleReset(formName) {
            this.$refs[formName].resetFields();
            this.checkedZone = [];
            setTimeout(() => {
                this.handleFilter();
            }, 500);
        },
        /**
         * @Description: 停用/启用
         * @Author: yangsibo
         * @Date: 2022-09-29 16:40:25
         * @param {*} handleStatus
         */
        async handleStatus(row, e) {
            let statusFlag = row.statusFlag == 20 ? 10 : 20;
            let statusFlagName = statusFlag == 10 ? '启用' : '停用';
            let { id } = row;
            let target = e.target;
            if (target.nodeName == 'SPAN') {
                target = e.target.parentNode;
            }
            target.blur();
            if (statusFlag == 20) {
                this.$confirm(
                    `是否确认${statusFlagName}该账号？`,
                    `${statusFlagName}提示`,
                    {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning',
                        center: true,
                    }
                )
                    .then(() => {
                        this.updateStatus({ id, statusFlag });
                    })
                    .catch(() => { });
            } else {
                this.updateStatus({ id, statusFlag });
            }
        },
        /**
         * @Description: 启用停用服务
         * @Author: yangsibo
         * @Date: 2022-09-29 16:53:50
         * @param {*} params
         */
        async updateStatus(params) {
            try {
                let { status, data } = await this.$http.bank.updateStatus(params);
                if (status == 1 && data) {
                    this.$message.success(
                        params.statusFlag == 10 ? '当前县账号已启用' : '当前县账号已停用'
                    );
                    this.getCtCountyAccountPage();
                } else {
                    this.$message.error(
                        params.statusFlag == 10 ? '当前县账号未启用' : '当前县账号未停用'
                    );
                }
            } catch (error) {
                console.log(error);
            }
        },
        /**
         * @Description: 打开弹窗
         * @Author: yangsibo
         * @Date: 2022-09-29 17:31:12
         * @param {*} row 当前数据
         * @param {*} type 弹窗类型
         * @return {*}
         */
        handleInfo(row, type) {
            this.currentData = JSON.parse(JSON.stringify(row));
            this.currentData.address = `${row.provinceName}>${row.cityName}>${row.areaName
                }`;
            switch (type) {
                case 'update':
                    this.getFinanceAccountDetail(
                        this.currentData.id,
                        `${row.provinceName}>${row.cityName}>${row.areaName}`
                    );
                    break;
                case 'reset':
                    this.dialogResetVisible = true;
                    break;
                default:
                    break;
            }
        },
        /**
         * @Description: 重置密码
         * @Author: yangsibo
         * @Date: 2022-09-29 17:03:14
         * @return {*}
         */
        handleResetInfo(formName) {
            this.$refs[formName].validate(async (valid) => {
                if (valid) {
                    let { id, userPassword } = this.currentData;
                    try {
                        let { status } = await this.$http.bank.updatePassword({
                            id,
                            userPassword,
                        });
                        if (status == 1) {
                            this.$message.success('当前县账号重置密码成功');
                            this.dialogResetVisible = false;
                        }
                    } catch (error) {
                        console.log(error);
                    }
                } else {
                }
            });
        },
        /**
         * @Description: 获取县账号详情
         * @Author: yangsibo
         * @Date: 2022-09-29 18:08:10
         * @param {*} id 当前县账号ID
         * @return {*}
         */
        async getFinanceAccountDetail(id, address) {
            try {
                let { data } = await this.$http.bank.getFinanceAccountDetail({ id });
                this.currentData = data;
                this.getCurrentDutyPerson();
                this.currentData.address = address;
                this.dialogUpdateVisible = true;
            } catch (error) { }
        },
        /**
         * @Description: 保存县账号更新信息
         * @Author: yangsibo
         * @Date: 2022-09-29 17:51:05
         * @param {*} formName 表单名称
         */
        handleSaveInfo(formName) {
            this.$refs[formName].validate(async (valid) => {
                if (valid) {
                    let {
                        id,
                        mobile,
                        fullName,
                        subDomain,
                        businessZoneId,
                        businessPersonId,
                        bankName,
                        businessOutlets,
                    } = this.currentData;
                    businessZoneId =
                        typeof businessZoneId == 'string'
                            ? businessZoneId
                            : businessZoneId[businessZoneId.length - 1];
                    try {
                        let { status } = await this.$http.bank.updateFinanceAccountById({
                            id,
                            mobile,
                            fullName,
                            subDomain,
                            businessZoneId,
                            businessPersonId,
                            bankName,
                            businessOutlets
                        });
                        if (status == 1) {
                            this.$message.success('当前县账号修改成功');
                            this.dialogUpdateVisible = false;
                            this.getCtCountyAccountPage();
                        }
                    } catch (error) {
                        console.log(error);
                    }
                } else {
                }
            });
        },
        // 银行机构
        bankAssociate(key,cb) {
            if (key !== '') {
                this.loading = true;
                this.$http.bank.fuzzyQueryList({key}).then( ({data}) => {
                this.loading = false;
                let arr = data.map( (item,index) => ({name:item,value:index}));
                cb(arr) // 渲染回调
                }).catch( res => {
                this.loading = false;
                })
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@/styles/common.scss';

.city-select {
    width: 160px;
}

::v-deep .dialog-bg {
    .el-form {
        .el-form-item {
            margin-bottom: 25px;
            .el-form-item__label {
                width: 120px !important;
            }
            .el-form-item__content {
                margin-left: 120px !important;
            }
            &.sub-domain-item {
                    .el-input {
                        input {
                            text-align: right;
                            padding-right: 50px;
            
                            &::-webkit-input-placeholder {
                                text-align: left;
                            }
            
                            &::-moz-placeholder {
                                text-align: left;
                            }
            
                            &::-ms-input-placeholder {
                                text-align: left;
                            }
            
                        }
            
                        .el-input__suffix-inner {
                            i {
                                display: inline-block;
                                height: 100%;
                                line-height: 40px;
                                color: #606266;
                                font-style: inherit;
                            }
            
                        }
                    }
                }
                &.mobile-form-item {
                    margin-bottom: 18px;
                }
    
                .login-tip {
                    height: 34px;
                    font-size: 14px;
                    color: #acacac;
                }
            }
        }
}
</style>
